export const optionsForFuelTransactionType: Array<string> = ['aral', 'ryd'];
